// src/graphql/tradeOrder/mutations.js

import { gql } from '@apollo/client/core'

export const ADD_TRADE_ORDER = gql`
  mutation addTradeOrder($input: TradeOrderInput!) {
    addTradeOrder(input: $input) {
      trade_order_id
      stock_id
      qty
      rule
      status
      created_at
      updated_at
      tradeStock {
        name
      }
      history {
        trade_order_history_id
        status
        created_at
      }
    }
  }
`
export const UPDATE_TRADE_ORDER = gql`
  mutation updateTradeOrder($id: ID!, $input: TradeOrderInput!) {
    updateTradeOrder(id: $id, input: $input) {
      trade_order_id
      stock_id
      qty
      rule
      status
      created_at
      updated_at
      tradeStock {
        name
      }
      history {
        trade_order_history_id
        status
        created_at
      }
    }
  }
`
export const DELETE_TRADE_ORDER = gql`
  mutation deleteTradeOrder($id: ID!) {
    deleteTradeOrder(id: $id)
  }
`